import type { Signal } from '@angular/core';
import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import type { OnyxTimeRange } from '@onyx/angular';
import type { OrderPointCategory } from '../enums/order-point-category';
import { orderTimeWindowDurationValidator } from './order-time-window-duration.validator';

export const orderOpeningHoursDateValidator =
  (
    category: Signal<OrderPointCategory.LOADING | OrderPointCategory.UNLOADING>,
    serviceTime: Signal<number | null>,
    timeRangeControl: AbstractControl<OnyxTimeRange | null>,
  ): ValidatorFn =>
  (control: AbstractControl<string | null>): ValidationErrors | null => {
    if (!control.value) return null;

    if (timeRangeControl.value == null) return { businessHoursClosedDay: true };

    const durationValidator = orderTimeWindowDurationValidator(
      category(),
      serviceTime(),
    );

    return durationValidator({
      value: timeRangeControl.value,
    } as AbstractControl<OnyxTimeRange | null>);
  };
